import {AuthService} from 'app/user/auth.service';

export function apiFactory(authService: AuthService) {
    return () => authService.init();
}